/* eslint-disable react/jsx-props-no-spreading */
import { FC, RefAttributes } from 'react'
import { RowDataType, RowKeyType, Cell as RsuiteCell } from 'rsuite-table'
import { InnerCellProps } from 'rsuite-table/lib/Cell'
import { Whisper, Tooltip } from 'rsuite'
import { CopyButton } from 'shared/atoms'

type Props = InnerCellProps<RowDataType<any>, RowKeyType> &
  RefAttributes<HTMLDivElement> & {
    allowedCopyFields?: string[]
  }

const Cell: FC<Props> = ({
  dataKey,
  rowData,
  allowedCopyFields,
  ...props
}: Props) => {
  const cellContent = rowData && dataKey ? rowData[dataKey] : ''

  return (
    <Whisper
      placement="bottom"
      trigger="hover"
      speaker={<Tooltip className="custom-tooltip">{cellContent}</Tooltip>}
    >
      <RsuiteCell
        dataKey={dataKey}
        {...props}
        style={{ position: 'relative', paddingRight: '35px' }}
      >
        {cellContent}
        {dataKey && allowedCopyFields?.includes(dataKey) && (
          <CopyButton
            text={cellContent || ''}
            style={{ position: 'absolute', right: '5px', top: '10px' }}
          />
        )}
      </RsuiteCell>
    </Whisper>
  )
}

export default Cell
